import { InternalLink, useLoggedInAuthContext } from 'common';

import { UserLabel } from '../Users/Label';

interface UserLinkProps {
  userId: string;
  fallbackOnError?: string;
}
export function UserLink(props: UserLinkProps) {
  const { isAdminRole } = useLoggedInAuthContext();
  const { userId, fallbackOnError } = props;

  if (isAdminRole) {
    return (
      <InternalLink to={`/users/${userId}`} onClick={(event) => event.stopPropagation()}>
        <UserLabel userId={userId} fallbackOnError={fallbackOnError} />
      </InternalLink>
    );
  }

  return <UserLabel userId={userId} fallbackOnError={fallbackOnError} />;
}
